module.exports = __webpack_public_path__ + "img/benefit-card-1-desktop.fcb58e4e.png";